import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CsPage } from 'providers/nav-controller';
import { MenuController } from 'providers/menu-controller';
import { CoachClaimService } from 'services/coach-claim.service';

@Component({
  selector: 'page-coach-claim',
  templateUrl: 'coach-claim.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachClaimPage extends CsPage<{}> {

  constructor(
    private menuCtrl: MenuController,
    private coachClaim: CoachClaimService,
  ) {
    super();
  }

  async ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }

  async ionViewDidEnter() {
    // fresh-claim path: processClaimAsync ends in a reloadAppAsync so control
    // does not return here on first claim. only the post-reload path reaches
    // waitForRoleAndUnstickAsync below, which no-ops unless the sessionStorage
    // bridge flag is still set (role didn't propagate before reload).
    await this.coachClaim.processClaimAsync({ checkOverwrite: true });
    await this.coachClaim.waitForRoleAndUnstickAsync();
  }

  async ionViewWillLeave() {
    this.menuCtrl.enable(true);
  }
}
